const config = {
  ru: {
    label: "RU",
    value: "ru",
    icon: "ic_flag-ru-border",
  },
  en: {
    label: "EN",
    value: "en",
    icon: "ic_flag-en",
  },
  hy: {
    label: "AM",
    value: "hy",
    icon: "ic_flag-armenia",
  },
  ky: {
    label: "KG",
    value: "ky",
    icon: "ic_flag-kyrgyzstan",
  },
  kk: {
    label: "KZ",
    value: "kk",
    icon: "ic_flag-kz",
  },
  uz: {
    label: "UZ",
    value: "uz",
    icon: "ic_flag-uzbekistan",
  },
};

const defaultConfig = {
  ru: config.ru,
  en: config.en,
};

export { config, defaultConfig };
